<template>
  <div class="product-info clearfix">
    <div class="product-image sr">
      <img class="img-responsive center-block" v-if="pic" :src="pic">
    </div>
    <div class="sr">
      <div class="product-name text-bold">{{ productName }}</div>
      <slot></slot>
      <h-button v-if="showBtn" round plain @click.native="reSelect">{{ btnTip || $t('evaluate.reChooseProduct') }}</h-button>
    </div>
  </div>
</template>

<style type="text/css" scoped>
@import 'config.css';

@media (--sm-viewport) {
  .sr {
    width: 50%;
    float: left;
  }
}

.product-info {
  position: relative;
  padding: 28px 16px;
  text-align: center;
}

.product-name {
  margin: 36px 0 40px;
  font-size: 18px;
}

.product-tip {
  margin-top: 8px;
}
</style>

<script type="text/javascript">
import hButton from '@/components/button';

export default {
  components: {
    hButton
  },
  // computed: {
  //   params () {
  //     // return this.$store.state.productParam.params;
  //   }
  // },

  props: {
    pic: String,
    productName: String,
    tip: {
      type: String,
      default: '正在评估'
    },
    btnTip: String,
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    reSelect () {
      this.$emit('back');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/core/evaluate/product-info.vue